export default __webpack_public_path__ + "static/media/super_admin.f6f841d6.svg";